import React, {Fragment} from 'react'
import {useParams} from 'react-router-dom'
import useDocument from 'admin/hooks/useDocument'
import Modal from 'admin/components/shared/Modal'
import Header from './shared/Header'
import useModal from '../hooks/useModal'
import useBankImport from '../hooks/useBankImport'
import ShowField from './shared/ShowField'
import {formatDate, formatTime} from '../lib/format'
import invert from 'invert-color'
import useBoolState from '../hooks/useBoolState'
import Deletion from './Deletion'

export default () => {
  const {organisationID} = useParams()
  const {bankImportId, popModal} = useModal()
  const {bankImport, destroy} = useBankImport(bankImportId)
  const [showConfirmDelete, setConfirmDelete, toggleConfirmDelete] = useBoolState()

  const title = `Import ${bankImportId}`
  useDocument({title})

  const handleClose = e => {
    e.preventDefault()
    popModal('bank-import', ['bankImportId'])
  }

  const handleDestroy = args => {
    destroy(args, () => {
      popModal('bank-import', ['bankImportId'])
    })
  }

  if (!bankImport.id) return null

  return (
    <Fragment>
      <Modal onClose={handleClose} flashId='edit-bank-import'>
        {organisationID !== bankImport.organisation.id && (
          <section
            style={
              bankImport.organisation.internalColor
                ? {backgroundColor: '#' + bankImport.organisation.internalColor}
                : {}
            }
            className={`py-3 section${bankImport.organisation.internalColor ? '' : ' has-background-info'}`}>
            <div className='container has-text-weight-semibold'>
              <span
                style={
                  bankImport.organisation.internalColor
                    ? {color: invert('#' + bankImport.organisation.internalColor, true)}
                    : {}
                }
                className={`is-size-7${bankImport.organisation.internalColor ? '' : ' has-text-light'}`}>
                This import was uploaded under{' '}
                <a
                  style={
                    bankImport.organisation.internalColor
                      ? {color: invert('#' + bankImport.organisation.internalColor, true)}
                      : {}
                  }
                  href={`/orgs/${bankImport.organisation.id}/payments/pending`}>
                  {bankImport.organisation.internalName}
                </a>
                .
              </span>
            </div>
          </section>
        )}
        <Header title={title}>
          <button className='button is-danger is-outlined' onClick={toggleConfirmDelete}>
            Delete
          </button>
          {bankImport.downloadUrl ? (
            <a href={bankImport.downloadUrl} target='_blank' className='button is-outlined is-dark'>
              Download original file
            </a>
          ) : null}
        </Header>
        <section className='section is-narrow'>
          <div className='container'>
            <ShowField alwaysHorizontal label='Name' value={bankImport.name} />
            <ShowField alwaysHorizontal label='Imported at' value={formatTime(bankImport.createdAt)} />
            <ShowField alwaysHorizontal label='Imported by' value={bankImport.importedBy} />
            <ShowField alwaysHorizontal label='Total payments' value={bankImport.totalCount} />
            <ShowField alwaysHorizontal label='Reconciled payments' value={bankImport.reconciledCount} />
            <ShowField alwaysHorizontal label='Ignored payments' value={bankImport.ignoredCount} />
            <ShowField alwaysHorizontal label='Deleted payments' value={bankImport.deletedCount} />
            <ShowField
              alwaysHorizontal
              label='Payments date range'
              value={`${formatDate(bankImport.fromDate)} - ${formatDate(bankImport.toDate)}`}
            />
          </div>
        </section>
      </Modal>
      {showConfirmDelete && <Deletion onConfirm={handleDestroy} onClose={toggleConfirmDelete} />}
    </Fragment>
  )
}
